export const DRAFTKINGS_PRIVACY_POLICY_URL = 'https://myaccount.draftkings.com/document/privacy';
export const MODELO_PRIVACY_NOTICE_URL = 'https://www.modelousa.com/pages/privacy-policy';
export const MODELO_USER_AGREEMENT_URL = 'https://www.modelousa.com/pages/terms-of-use';

export const DEFAULT_MARKETING_CONSENT_COPY = {
  headline: '$85,000 IN TOTAL PRIZES',
  subheadline: 'Brewed for Legendary Wins',
  checkboxPrompt: 'Check the box below to receive exclusive offers, news, and updates from Modelo.',
  eligibilityText:
    "Participants must be 21+ to enter and a U.S. resident of the United States/DC. By clicking 'PLAY FREE' I affirm that I am 21 or older and a resident of the U.S. states/DC and have read and agree to the official rules.",
  footerText:
    "*For details about DraftKings' collection and use of your information, please see our Privacy Policy. You may opt out of having your information shared with Modelo by emailing privacy@cbrands.com.",
  buttonText: 'PLAY FREE',
} as const;

/**
 * Whether the landing marketing consent modal should appear for this contest.
 * Default OFF: only enabled when explicitly turned on in admin, or via
 * VITE_PICKEM_MARKETING_CONSENT=1 (staging override). An absent or false
 * style_config flag keeps the modal hidden.
 */
export function shouldShowMarketingConsentModal(
  styleConfig: Record<string, unknown> | undefined
): boolean {
  if (styleConfig?.showMarketingConsentModal === false) return false;
  if (styleConfig?.showMarketingConsentModal === true) return true;
  if (import.meta.env.VITE_PICKEM_MARKETING_CONSENT === '1') return true;
  return false;
}
